import { render, staticRenderFns } from "./Relative.vue?vue&type=template&id=a0b5e414&"
import script from "./Relative.vue?vue&type=script&lang=js&"
export * from "./Relative.vue?vue&type=script&lang=js&"
import style0 from "./Relative.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0b5e414')) {
      api.createRecord('a0b5e414', component.options)
    } else {
      api.reload('a0b5e414', component.options)
    }
    module.hot.accept("./Relative.vue?vue&type=template&id=a0b5e414&", function () {
      api.rerender('a0b5e414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/Relative.vue"
export default component.exports